// extracted by mini-css-extract-plugin
export default {"secret__wrapper":"Managers_secret__wrapper__2Ml8J","secret__wrapperError":"Managers_secret__wrapperError__6JOo7"};